// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cxvt","colBig":"styles_colBig__L_mVl","colSmall":"styles_colSmall__ReB9-","shopifyNameWrapper":"styles_shopifyNameWrapper__14U5Y"};